import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material'

export const NoticeDialog = () => {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    sessionStorage.getItem('noticeDialogOpen') || setOpen(true)
  }, [])

  const closeNoticeDialog = () => {
    setOpen(false)
    sessionStorage.setItem('noticeDialogOpen', 'true')
  }

  return (
    <Dialog open={open} onClose={closeNoticeDialog}>
      <DialogTitle>{'ご利用にあたって'}</DialogTitle>
      <DialogContent>
        <DialogContentText whiteSpace={'pre-wrap'}>
          <Typography variant='body2' mb={2}>■「巴川浸水情報システム」は、気象庁から公表された実績雨量データを、巴川の河道断面、地形等のデータと組み合わせ、<u>浸水が推定される区域等の情報を表示するもの</u>です。</Typography>
          <Typography variant='body2' mb={2}>■ 本システムに表示される情報は、様々な要因により実際の状況と異なる場合があります。また、通信状況等により表示される情報の更新に遅延が生じる場合があります。</Typography>
          <Typography variant='body2' mb={2}>■ 浸水センサは機器底面が５分間継続して浸水した場合に浸水状態と判定し、凡例の水位の色に応じて着色されます。</Typography>
          <Typography variant='body2' mb={2}>■ センサ機器の故障や通信異常等による異常値がそのまま表示されてしまう可能性があります。ご利用の際にはご注意ください。</Typography>
          <Typography variant='body2' mb={2}>■ 浸水推定区域として表示されていない地域においても浸水が発生していたり、推定よりも浸水の程度が大きくなっている可能性があるため、<u>水位観測所の水位情報、気象警報・注意報 、避難情報等にも十分注意して、早期の避難を心掛けてください。</u></Typography>
          <Typography variant='body2' mb={2}>■ 本システムの保守等を目的として、予告なく表示画面の変更、閲覧の中断、停止等の措置をとることがあります。ご了承ください。</Typography>
          <Typography variant='body2' mb={2}>■ 静岡市は、本システムの利用者がシステム内の情報を用いて行う一切の行為（当該情報を編集・加工等した情報を利用することを含む。）について何ら責任を負うものではありません。</Typography>
          <Typography variant='body2' mb={2}>■ <u>静岡市は、本システムの利用によって発生する直接又は間接の損失、損害、障害等について一切責任を負いません。</u></Typography>
          <Typography variant='body2' mb={0}>■ 本システムの閲覧には、 Edge、Firefox、Google Chrome、Safariを推奨しております。これら以外の閲覧環境では、情報が正確に表示されない、動作が遅いといった不具合が生じることがあります。</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeNoticeDialog}> 閉じる </Button>
      </DialogActions>
    </Dialog>
  )
}
